import script from "./prototypeRoomList.vue?vue&type=script&lang=ts&setup=true"
export * from "./prototypeRoomList.vue?vue&type=script&lang=ts&setup=true"

import "./prototypeRoomList.vue?vue&type=style&index=0&id=1318f074&lang=less"

const __exports__ = script;

export default __exports__